import api from 'api/apiInstance';

export function clientTodoListSendUpdateMailApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
